import { Base } from '../base-component';

import './hero-banner.component.scss';
import Slider from '../slider/slider.component';
import { MediaQueryService } from '../../services/media-query.service';

export class HeroBanner extends Base {

	sliderContainer: Element;
	sliderPagination: Element;
	sliderConfig: SwiperOptions;
	sliderNext: Element;
	sliderPrev: Element;

	constructor(element: Element) {
		super(element);
	}

	init() {

		this.sliderContainer = this.element.querySelector('.swiper-container');
		this.sliderPagination = this.element.querySelector('.swiper-pagination');
		this.sliderNext = this.element.querySelector('.swiper-button-next');
		this.sliderPrev = this.element.querySelector('.swiper-button-prev');

		this.sliderConfig = {
			slidesPerView: 1,
			spaceBetween: 0,
			initialSlide: 0,
			pagination: {
				el: this.sliderPagination,
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: this.sliderNext,
				prevEl: this.sliderPrev
			},
			autoplay: {
				delay: 7000
			}
		};

		Slider.init(this.sliderContainer, this.sliderConfig);

	}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/hero-banner/hero-banner.component.ts